// IMPORTS
// Modules
import { useState, useEffect } from 'react';
import $ from 'jquery';
// OHS
import OHSWidget from '../../../../../onehivesystems/js/OHSWidget';
import OHSMultiTab from '../../../../../onehivesystems/js/OHSMultiTab';
import OHSImages from '../../../../../onehivesystems/js/OHSImages';
import { OHSListDataFormatter } from '../../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
// Assets
import PortTypeImage from './PortTypeImage';
import PortTemplates from './PortTemplates';
import GeneralInformation from './GeneralInformation';
import Fields from './Fields';
import { portModel } from '../_variables';


// COMPONENT
export default function Port (props) {
   // States and Variables
   const [portStatus, setPortStatus] = useState(null);
   const [images, setImages] = useState(null);

   // On-Load
   useEffect(function () {
      setPortStatus(props.parent.getPortStatus(props.content));
      getImages();
   }, []);

   // Functions
   const updatePort = function () {
      OHSCRUD({
         url: '/v1/oneport/ports/' + props.content.id.value,
         method: 'PUT',
         payload: buildPayload(),
         success: function (data) {
            var temp = props.parent.ports;
            temp[props.index] = OHSListDataFormatter(data[0], portModel);
            props.parent.setPorts(temp);
            setPortStatus(props.parent.getPortStatus(temp[props.index]));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const deletePort = function () {
      OHSCRUD({
         url: '/v1/oneport/ports/' + props.content.id.value,
         method: 'DELETE',
         success: function () {
            props.hidePopup(props.index);
            var temp = props.parent.ports;
            temp.splice(props.index, 1);
            props.parent.setPorts(temp);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to delete this port?",
         showSuccessPopup: true
      });
   }
   const getImages = function () {
      OHSCRUD({
         url: '/v1/oneport/files/list/' + props.content.id.value,
         method: 'GET',
         success: function (data) {
            setImages(data);
         },
         setOHSPopup: props.onehive.setPopup
      });
   }
   const uploadImage = function (inputID) {
      // Build Form with Image
      const data = new FormData();
      data.append('file', $('#' + inputID)[0].files[0]);

      // Perform API Call
      OHSCRUD({
         url: '/v1/oneport/files/' + props.content.id.value,
         method: 'POST',
         payload: data,
         file: true,
         success: function (data) {
            getImages();
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const updateImage = function (id, inputID) {
      // Build Form with Image
      const data = new FormData();
      data.append('file', $('#' + inputID)[0].files[0]);

      // Perform API Call
      OHSCRUD({
         url: '/v1/oneport/files/' + id,
         method: 'PUT',
         payload: data,
         file: true,
         success: function (data) {
            getImages();
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         showSuccessPopup: true,
         confirmMessage: "Are you sure you wish to update this existing image?"
      });
   }
   const deleteImage = function (id, index) {
      OHSCRUD({
         url: '/v1/oneport/files/' + id,
         method: 'DELETE',
         success: function (data) {
            var temp = images;
            temp.splice(index, 1);
            setImages(temp);
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         showSuccessPopup: true,
         confirmMessage: "Are you sure you wish to delete this image?"
      });
   }
   const buildPayload = function () {
      var master = {};
      var portinfo = JSON.parse(OHSFormDataExtractor('oneport-port-' + props.index + '-portinfo'));
      master['name'] = portinfo.name;
      master['port_type'] = portinfo.port_type;
      master['mapped_device'] = portinfo.mapped_device;
      master['expiration'] = portinfo.expiration;
      master['unusable'] = portinfo.unusable;
      master['fields'] = JSON.parse(OHSFormDataExtractor('oneport-port-' + props.index + '-fields'));;
      return JSON.stringify(master);
   }

   // Component
   return (
      <div id={`oneport-port-${props.index}`} className='oneport-port' onKeyDown={(e) => {OHSFormSubmitListener(e, updatePort);}}>
         <div className={portStatus === "broken" ? 'oneport-port-portstatus oneport-port-portstatus-broken' : portStatus === "patched" ? 'oneport-port-portstatus oneport-port-portstatus-patched' : 'oneport-port-portstatus'}>
            <PortTypeImage onehive={props.onehive} value={props.content.port_type.value} />
            <p>{portStatus}</p>
         </div>
         <OHSMultiTab onehive={props.onehive} content={[
            {
               title: "Images",
               content: <OHSImages onehive={props.onehive} images={images} setImages={setImages} upload={uploadImage} update={updateImage} delete={deleteImage} />
            },
            {
               title: "Port Templates",
               content: <PortTemplates onehive={props.onehive} parent={{
                  content: props.content,
                  index: props.index,
                  ports: props.parent.ports,
                  setPorts: props.parent.setPorts,
                  getPortStatus: props.parent.getPortStatus,
                  setPortStatus: setPortStatus,
                  portTemplates: props.parent.portTemplates,
                  hidePopup: props.hidePopup
               }} />
            }
         ]} />
         <OHSWidget onehive={props.onehive} id={`oneport-port-${props.index}-portinfo`} className="oneport-port-portinfo" title="General Information">
            <GeneralInformation onehive={props.onehive} parent={{
               content: props.content,
               devices: props.parent.devices
            }} />
         </OHSWidget>
         <OHSWidget onehive={props.onehive} id={`oneport-port-${props.index}-fields`} className="oneport-port-fields" title="Fields">
            {portStatus === "broken" && <p className='oneport-port-fieldsdisabled'>--- Port marked as broken/unusable - Editing of fields is not available ---</p>}
            {props.parent.fields && props.parent.fields.length > 0 && props.parent.fields.map(function (field, i) {
               return (
                  <OHSFormItem onehive={props.onehive} key={`oneport-port-${props.index}-field-${i}`} title={field.name}>
                     <Fields onehive={props.onehive} parent={{
                        type: field.type,
                        defaultvalue: props.content[field.id].value,
                        disabled: portStatus === "broken",
                        ohsformdata: field.id,
                        selectContent: field.options && field.options.split("\n"),
                        selectSimple: true,
                        selectBlank: true
                     }} />
                  </OHSFormItem>
               );
            })}
         </OHSWidget>
         <OHSFormSubmit onehive={props.onehive} update={updatePort} delete={deletePort} keyListener={true} />
      </div>
   );
}